@use "@fukuri-admins/ui/layout" as *;

.Screen {
  display: flex;
  background-color: background('Primary');
  padding-left: $SideMenuWidth;
  min-height: 100vh;
  @media screen and (max-width: $TB) {
    flex-direction: column;
    padding-left: 0;
    padding-top: 40px;
  }
}

.ContentWrapper {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  width: 100%;
}

.BreadcrumbWrapper {
  border-bottom: 1px solid border("Tertiary");
  padding: spacing("16") spacing("24");
}

.Content {
  display: flex;
  flex-direction: column;
  gap: spacing("24");
  padding: spacing("24");
}

.BannerWrapper {
  position: fixed;
  bottom: spacing('24');
  right: spacing('24');
}